import { formatarPct, formatarQtd, formatarReais } from '@profitlens/calculo';

/**
 * Padrão 1 da especificação: AUSENTE NUNCA VIRA ZERO.
 *
 * Um fornecedor que não informou o frete não cobra frete zero — ele
 * simplesmente não informou. Tratar os dois como a mesma coisa é o jeito mais
 * rápido de aprovar um negócio ruim (RN-044).
 *
 * Por isso não existe `?? 0` em lugar nenhum deste componente.
 */

function NaoInformado({ rotulo = 'n/i' }: { rotulo?: string }) {
  return (
    <span className="font-sans text-tinta-3 italic" title="Não informado — não é zero">
      {rotulo}
    </span>
  );
}

export function Reais({ cents, className = '' }: { cents: number | null | undefined; className?: string }) {
  if (cents === null || cents === undefined) return <NaoInformado />;
  return <span className={`num ${className}`}>{formatarReais(cents)}</span>;
}

export function Percentual({ bps, className = '' }: { bps: number | null | undefined; className?: string }) {
  if (bps === null || bps === undefined) return <NaoInformado />;
  return <span className={`num ${className}`}>{formatarPct(bps)}</span>;
}

export function Quantidade({
  milli,
  unidade,
  className = '',
}: {
  milli: number | null | undefined;
  unidade?: string | null;
  className?: string;
}) {
  if (milli === null || milli === undefined) return <NaoInformado />;
  return (
    <span className={`num ${className}`}>
      {formatarQtd(milli)}
      {unidade ? <span className="ml-1 text-tinta-3">{unidade}</span> : null}
    </span>
  );
}

export function Dias({ dias }: { dias: number | null | undefined }) {
  if (dias === null || dias === undefined) return <NaoInformado />;
  return (
    <span className="num">
      {dias} <span className="text-tinta-3">{dias === 1 ? 'dia' : 'dias'}</span>
    </span>
  );
}

/**
 * Indicador sem base de cálculo (RN-086). Diferente de "não informado":
 * aqui o dado existe mas não pode ser derivado ainda — como o giro de estoque
 * com uma única coleta. Nunca exibido como zero.
 */
export function Indeterminado({ motivo }: { motivo: string }) {
  return (
    <span className="font-sans text-sm text-tinta-3 italic" title={motivo}>
      dados insuficientes
    </span>
  );
}

export function Texto({ valor }: { valor: string | null | undefined }) {
  if (valor === null || valor === undefined || valor.trim() === '') return <NaoInformado />;
  return <span>{valor}</span>;
}

export function DataBR({ iso }: { iso: string | null | undefined }) {
  if (!iso) return <NaoInformado />;
  const [a, m, d] = iso.split('-');
  if (!a || !m || !d) return <NaoInformado />;
  return <span className="num">{`${d}/${m}/${a}`}</span>;
}
